export class InitWorksheetsCategories  {
  public static readonly type = '[Worksheets] InitWorksheetsCategories';
  constructor() {}
}
export class InitWorksheetsItems  {
  public static readonly type = '[Worksheets] InitWorksheetsItems';
  constructor() {}
}
